var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldRefreshRightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zM6.25 12.26c0-3.17 2.58-5.75 5.75-5.75.14 0 .29.02.43.03l-.28-.32a.756.756 0 0 1 .07-1.06c.31-.27.79-.24 1.06.07l1.67 1.91c.01.01.01.02.02.03.01.01.02.01.02.02.02.03.03.07.05.11.02.05.05.09.06.14.01.05.01.09.02.14 0 .05.01.09.01.14 0 .05-.02.09-.04.14-.02.05-.03.1-.05.14-.02.04-.06.08-.09.12-.03.03-.04.07-.07.09-.01.01-.02.01-.03.02-.01.01-.01.02-.02.02l-1.94 1.42a.72.72 0 0 1-.44.14c-.23 0-.46-.11-.61-.31-.24-.33-.17-.8.16-1.05l.56-.41c-.19-.01-.37-.03-.56-.03a4.26 4.26 0 0 0-4.25 4.25A4.26 4.26 0 0 0 12 16.51a4.26 4.26 0 0 0 4.25-4.25c0-.85-.25-1.66-.71-2.36a.746.746 0 0 1 .21-1.04c.34-.23.81-.14 1.04.21.63.95.97 2.05.97 3.19A5.766 5.766 0 0 1 12 18.01c-3.17 0-5.75-2.58-5.75-5.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRefreshRightSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-refresh-right-square.550bd9c5242b855bf5996c01d7f23a7f.svg";
export { ForwardRef as ReactComponent };